export const copy = {
  home: {
    hero: {
      eyebrow: '実践メディア',
      title: '作って、直して、\n速くする。',
      lead: 'AIを使って何かを作る・整える・速くする過程を、実務に転用できる形で届けます。読んで終わりじゃなく、手を動かすための実践メディア。',
      ctaPrimary: '記事を読む',
      ctaSecondary: '制作記録を見る',
    },
    nowBuilding: {
      label: '現在制作中',
      title: 'つくってなんぼ — このサイト自体',
      desc: 'AIを使った実践ブログの制作記録を公開しながら進めています。仕様設計・デザイン・実装・SEOまで、全工程をシリーズ記事にする予定。',
      progress: 65,
    },
    featured: {
      label: '注目記事',
      more: 'すべて見る',
    },
    series: {
      label: '進行中シリーズ',
      title: '制作記録ログ',
      desc: '1つのプロジェクトを作りながら、その過程で生まれた課題・工夫・判断を記事にしています。補助記事から読んでもメインからでもOK。',
      cta: 'シリーズを読む',
    },
    categories: {
      label: 'カテゴリ',
      title: '4つのテーマで発信',
    },
    latest: {
      label: '最新記事',
      title: '最新記事',
      moreCta: '全記事を見る',
    },
    cta: {
      title: '次の作業に着手できる記事を届けます',
      desc: '新しい記事が出たらすぐ読みたい方は、Xをフォローしてください。',
      button: '全記事を見る',
    },
  },
  about: {
    title: 'つくってなんぼ について',
  },
} as const;
